/**
 * Dynamic template and script loader.
 */

// load up dust right away and apply the helpers
'use strict';

exports.__esModule = true;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _dustjsLinkedin = require('dustjs-linkedin');

var _dustjsLinkedin2 = _interopRequireDefault(_dustjsLinkedin);

require('../lib/dust-helpers-1.1.1');

require('../lib/dust-helpers-supplement');

// has to go after the previous one

require('../lib/dust-helper-iterate');

// all of the internal helpers

var _ajax = require('./ajax');

var ajaxLoader = _interopRequireWildcard(_ajax);

var _loader = require('./loader');

var templateLoader = _interopRequireWildcard(_loader);

var _createLoader = require('./createLoader');

var _createLoader2 = _interopRequireDefault(_createLoader);

var _renderer = require('./renderer');

var _renderer2 = _interopRequireDefault(_renderer);

// require window.Promise
if (!window.Promise) {
	log('Promise is required to use this module');
}

// warn if there is more than one forklifter around
if (window.__forklifter__) {
	log('More than one forklifter instance found');
} else {
	window.__forklifter__ = true;
}

if (typeof window === 'object') {
	window.dust = _dustjsLinkedin2['default'];
}

// export specifiers here, not an object
exports.ajaxLoader = ajaxLoader;
exports.templateLoader = templateLoader;
exports.createLoader = _createLoader2['default'];
exports.renderer = _renderer2['default'];
exports.dust = _dustjsLinkedin2['default'];

// simple log abstraction
function log(msg) {
	if (typeof console !== 'undefined') {
		console.error(msg); // eslint-disable-line no-console
	}
}


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/forklifter/dist/index.js
// module id = 187
// module chunks = 0 1 2 4 5 6